import { Controller } from "@hotwired/stimulus"

const TURNSTILE_API_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=labsTurnstileLoaded"

let turnstileApiPromise = null

function loadTurnstileApi() {
  if (window.turnstile?.render) return Promise.resolve()

  turnstileApiPromise ||= new Promise((resolve, reject) => {
    window.labsTurnstileLoaded = resolve

    const script = document.createElement("script")
    script.src = TURNSTILE_API_URL
    script.async = true
    script.onerror = () => {
      turnstileApiPromise = null
      reject(new Error("Turnstile API failed to load"))
    }

    document.head.append(script)
  })

  return turnstileApiPromise
}

export default class extends Controller {
  static targets = ["widget"]
  static values = {
    siteKey: String,
    action: String,
    theme: String,
    size: String,
    appearance: String
  }

  initialize() {
    this.widgetId = null
  }

  connect() {
    loadTurnstileApi()
      .then(() => {
        if (this.element.isConnected) this.render()
      })
      .catch((error) => console.warn("turnstile: failed to load", error))
  }

  disconnect() {
    this.removeWidget()
  }

  render() {
    if (this.widgetId !== null) return

    this.widgetTarget.replaceChildren()
    this.widgetId = window.turnstile.render(this.widgetTarget, this.renderOptions)
    this.widgetTarget.dataset.turnstileWidgetId = this.widgetId
  }

  removeWidget() {
    if (this.widgetId === null) return

    window.turnstile.remove(this.widgetId)
    this.widgetId = null
    delete this.widgetTarget.dataset.turnstileWidgetId
    this.widgetTarget.replaceChildren()
  }

  get renderOptions() {
    return {
      sitekey: this.siteKeyValue,
      action: this.actionValue,
      theme: this.themeValue,
      size: this.sizeValue,
      appearance: this.appearanceValue
    }
  }
}
